import styled from 'styled-components/macro';

export const StickyContainer = styled.div<{ top: number; bgColor: string }>`
  position: sticky;
  top: 0;
  z-index: 300;
  background-color: ${({ bgColor }) => bgColor};
`;

export const StickyInner = styled.div<{ round: number; bgColor: string }>`
  background-color: ${({ bgColor }) => bgColor};
  border-radius: ${({ round }) => `${round}px ${round}px 0 0`};
`;
